"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const autobind_decorator_1 = require("autobind-decorator");
const React = require("react");
const react_json_view_1 = require("react-json-view");
const TitleComponent_1 = require("./TitleComponent");
let JsonEditComponent = class JsonEditComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.handleModify = (addPayload) => {
            if (this.props.readonly) {
                return false;
            }
            try {
                JSON.stringify(addPayload.updated_src);
            }
            catch (e) {
                console.error(`Invalid JSON. Culprit: ${this.props.field}`);
                return false;
            }
            this.props.modelChanged(this.props.field, addPayload.updated_src);
            return true;
        };
    }
    render() {
        const { field, currentModel } = this.props;
        return (React.createElement("div", null,
            field.title && React.createElement("span", null,
                React.createElement(TitleComponent_1.TitleComponent, { field: field }),
                React.createElement("br", null)),
            React.createElement(react_json_view_1.default, { style: { borderWidth: "2px" }, name: field.field, src: currentModel, onAdd: this.handleModify, onEdit: this.handleModify, onDelete: this.handleModify })));
    }
};
JsonEditComponent = __decorate([
    autobind_decorator_1.default
], JsonEditComponent);
exports.JsonEditComponent = JsonEditComponent;
//# sourceMappingURL=JsonEditComponent.js.map